import res from './res'

res.add('en', {
    title: 'Table customization',
    rowsCount: 'Page row count:',
    fieldsSettings: 'Customize fields visibility and order',
    applyButton: 'OK',
    cancelButton: 'Cancel'
})
